import { type Messages } from ".";

export const messagesPL: Messages = {
  HOME: {
    TITLE: "Panel",
    ROUTE: "/dashboard",
    PAGE: "Witamy w DASF",
    INTRO: "Potężne narzędzie do oceny zarządzania kryzysowego",
    SECTION1_TITLE: "Funkcje",
    SECTION1: "Aplikacja wspiera ocenę zdolności w zarządzaniu kryzysowym.",
    SECTION2_TITLE: "Technologia",
    SECTION2: "Zbudowane z TypeScript i nowoczesnymi technologiami webowymi.",
    SECTION3_TITLE: "Użytkowanie",
    SECTION3: "Nawiguj po sekcjach za pomocą paska nawigacyjnego.",
  },
  ABOUT: {
    TITLE: "O aplikacji",
    ROUTE: "/about",
    PAGE: "O programie DASF",
    INTRO: "Dowiedz się więcej o DIREKTION Assessment & Screening Framework",
    SECTION1_TITLE: "Czym jest DASF",
    SECTION1:
      "DIREKTION Assessment & Screening Framework wspiera organizacje w zarządzaniu kryzysowym.",
    SECTION2_TITLE: "Główne funkcje",
    SECTION2:
      "Ocena zdolności, identyfikacja luk, ocena rozwiązań i harmonogram wdrożenia.",
    SECTION3_TITLE: "Cele rozwoju",
    SECTION3:
      "Zapewnienie przejrzystego i łatwego w utrzymaniu frameworku zarządzania kryzysowego.",
  },
  SETTINGS: {
    TITLE: "Ustawienia",
    ROUTE: "/settings",
    PAGE: "Ustawienia aplikacji",
    INTRO: "Skonfiguruj preferencje aplikacji",
    SECTION1_TITLE: "Preferencje językowe",
    SECTION1: "Zmień język spośród dostępnych opcji.",
    SECTION2_TITLE: "Ustawienia wyglądu",
    SECTION2: "Dostosuj wygląd aplikacji.",
    SECTION3_TITLE: "Preferencje",
    SECTION3: "Zarządzaj zachowaniem aplikacji.",
  },
  LANDING: { TITLE: "Wprowadzenie", ROUTE: "/" },
  HAZARDS: { TITLE: "Zagrożenia", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Rozwiązania", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Plan działania", ROUTE: "/roadmap" },
  USER: "Użytkownik",
  EDITOR: "Edytor",
  ADMIN: "Administrator",
  CANCEL: "Anuluj",
  DELETE: "Usuń",
  YES: "Tak",
  NO: "Nie",
  OK: "OK",
  NAME: "Nazwa",
  DESCRIPTION: "Opis",
  DELETE_ITEM: {
    TITLE: "Usuń {item}",
    DESCRIPTION:
      "Czy na pewno chcesz usunąć ten {item}? Tej operacji nie można cofnąć.",
  },
  SAVE_BUTTON: {
    LABEL: "Zapisz",
    TOOLTIP: "Zapisz niezapisane zmiany",
  },
  SEARCH: "Szukaj...",
  SEARCH_TOOLTIP: "Wpisz / aby wyszukać",
  LANGUAGE: "Język",
  CLEAR: "Wyczyść model",
  UPLOAD: "Prześlij model jako JSON",
  DOWNLOAD: "Pobierz model jako JSON",
  PERMALINK: "Utwórz stały link",
  ROLE: "Rola",
  LINK: "Link",
  MODEL: "Model",
  TITLE: "Tytuł",
  AUTHORS: "Autorzy",
  TYPE: "Typ",
  HITS: {
    n: "{n} Wyników",
  },
  NO_RESULTS: "Nie znaleziono wyników",
  CLEAR_SEARCH: "Wyczyść wyszukiwanie",
  PAGE_NOT_FOUND: "Strona nie znaleziona",

  about_route: "/about",
  about: "O aplikacji",
  acronym: "Akronim",
  add_term: "Dodaj nowy termin",
  addr_how: "Jak jest adresowane?",
  addressed: "Zaadresowane",
  ass_instr: "_Oceń wkład zdolności w realizację Twoich celów._",
  ass_label: "Przyczyna problemu jest dobrze znana",
  ass_overall: "Potrzeba poprawy",
  ass_scale: "Skala oceny",
  ass_setting: "Macierz oceny",
  ass: "Ocena",
  assess_content: "Określ dla każdej zdolności jej ważność i aktualne wyniki.",
  assess: "Oceń",
  assessment_route: "/assessment/:id",
  assessment: "Ocena",
  avg_perf: "Ogólna ocena",
  cap_cat: "Kategoria zdolności",
  cap: "Zdolność",
  caps: "Zdolności",
  cat: "Kategoria",
  clear_all: "Usuń wszystkie filtry",
  clear: "Wyczyść",
  color: "Kolor",
  create_cap: "Utwórz zdolność",
  defs: "Definicje",
  del_model: "Czy na pewno chcesz usunąć wszystko?",
  del_model_desc: "Czy jesteś pewien, że chcesz usunąć swój model?",
  del_proj: "Usuń projekt",
  desc_cap_instr: "Opisz zdolność szczegółowo.",
  desc: "Opis",
  develop_content: "Zacznij rozwijać swoje zdolności.",
  develop: "Rozwijaj",
  development: "Rozwój",
  development_route: "/development/:id",
  dev_cap:
    "_Zaproponuj nowe projekty, aby rozwinąć swoją zdolność. Zacznij od wybrania zdolności._",
  doc_id: "ID dokumentu",
  doc: "Dokumentacja",
  download: "Pobierz",
  duration: "Czas trwania",
  edit: "Edytuj",
  view: "Widok",
  evaluation_route: "/evaluation/:id",
  evaluation: "Ocena",
  exp_perf: "Oczekiwana wydajność",
  expl: "Wyjaśnienie",
  expl2: "Wydajność",
  filter_cap: "Filtruj zdolności",
  filter_caps: "Filtruj zdolności",
  filter_ph: "Tytuł lub opis",
  filter_text_ph: "Termin lub opis",
  filter_text: "Tekst filtru",
  filters: "Filtry",
  relevance: "Trafność",
  gap_scale: "Skala dla luki",
  gap_settings: "##### Ustawienia luk",
  gap: "Luka",
  gaps_common: "Typowe luki lub przyczyny problemów",
  gaps: "Luki",
  gng: "###### Decyzja GO / NO GO<br>",
  go: "GO",
  goal_scale: "Skala dla tematów oceny",
  goals_instr: "Określ cele długo- i krótkoterminowe",
  goal: "Cel",
  goals: "Cele",
  group_goals_instr:
    "1. **Ustal cele grupowe, które chcesz osiągnąć.**\n2. Określ swoich interesariuszy i ich cele organizacyjne.\n3. Określ kategorie zdolności, aby zorganizować zdolności.\n4. Określ zdolności potrzebne do osiągnięcia celów grupowych.",
  group_goals: "Określ cele grupowe",
  home_route: "/",
  home: "STRONA GŁÓWNA",
  id: "ID",
  importance: "Ważność",
  in_months: "W miesiącach",
  loc: "Pomieszczenie/lokalizacja",
  main_goals: "Cele",
  assess_capability_importance_for_capability:
    'Oceń znaczenie "{capability}" dla wybranego zakresu.',
  max_imp: "Maksymalny wkład",
  name: "Nazwa",
  no_go: "NO GO",
  no: "Nie",
  org_dept: "Organizacja / Dział",
  overview_route: "/overview",
  overview: "Przegląd",
  level: "Poziom",
  perf_asp: "Aspekt wydajności",
  perf_asps: "Aspekty wydajności",
  assess_performance_aspects_for_capability:
    "Oceń aspekty wydajności dla {capability}.",
  perf_effectiveness_tooltip: "Jak skuteczna jest {capability}?",
  perf_safety_professionals_tooltip:
    "Jaki jest poziom bezpieczeństwa fizycznego i psychicznego personelu operacyjnego pracującego nad {capability}?",
  perf_efficiency_tooltip: "Jak wydajna jest {capability}?",
  perf_scale: "Skala dla punktacji wydajności",
  perf_settings: "##### Ustawienia oceny",
  perf: "Wydajność",
  period: "RRRR K1 lub RRRR M1",
  permalink: "Stały link",
  pers_inv: "Zaangażowane osoby",
  pick_more: "Wybierz jeden lub więcej",
  pick_one: "Wybierz jeden",
  prep_content: "_Zdefiniuj cele swojej organizacji._",
  preparation_route: "/swojej",
  preparation: "Swojej",
  prepare_content: "Utwórz lub wybierz ważne zdolności.",
  prepare: "Przygotuj",
  prob_areas: "Obszary problemowe",
  gap_problem_categories_intro:
    "Przeanalizuj tę lukę zdolności w następujących kategoriach problemów.",
  gap_likert_severity: "Dotkliwość",
  gap_likert_severity_start_label: "Bardzo niska",
  gap_likert_severity_middle_label: "Średnia",
  gap_likert_severity_end_label: "Bardzo wysoka",
  gap_likert_probability: "Prawdopodobieństwo",
  gap_likert_probability_start_label: "Brak zmian",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Duży spadek",
  gap_likert_impact: "Wpływ",
  gap_likert_impact_start_label: "Brak zmian",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Duży spadek",
  gap_likert_severity_tooltip: "Jak oceniasz dotkliwość tej luki zdolności?",
  gap_likert_probability_tooltip:
    "Załóżmy, że luka została usunięta: co to oznaczałoby dla prawdopodobieństwa wystąpienia luki?",
  gap_likert_impact_tooltip:
    "Załóżmy, że luka została usunięta. Co to oznaczałoby dla zmniejszenia wpływu pierwotnej luki?",
  prob: "Problem",
  proj_app: "###### PROJEKT ZATWIERDZONY<br>",
  proj_name: "Nazwa projektu",
  proj_prop: "Nowy projekt lub propozycja",
  proj_sum: "Podsumowanie projektu",
  prop_name: "Nazwa propozycji",
  prop_new: "Nowa propozycja",
  ref: "Odniesienie",
  ref_url: "URL odniesienia",
  select_cap: "Wybierz zdolność",
  select_cat: "Wybierz kategorię",
  select_m_ph: "Wybierz jeden lub więcej",
  select_subcat: "Wybierz podkategorię",
  settings_route: "/settings",
  settings: "Ustawienia",
  sh_filter: "Filtruj zaangażowane organizacje",
  sh_org: "Organizacje interesariuszy",
  sh_settings: "##### Ustawienia interesariuszy",
  sh_type: "Typ interesariusza",
  sh_types: "Typy interesariuszy",
  sh: "Interesariusz",
  shs: "Interesariusze",
  other_stakeholder: "Proszę opisać innego interesariusza",
  spec_cap_instr:
    "1. Ustal cele grupowe, które chcesz osiągnąć.\n2. Określ swoich interesariuszy i ich cele organizacyjne.\n3. Określ kategorie zdolności, aby zorganizować zdolności.\n4. **Określ zdolności potrzebne do osiągnięcia celów grupowych.**",
  spec_cap: "Określ zdolności",
  spec_cat_instr:
    "1. Ustal cele grupowe, które chcesz osiągnąć.\n2. Określ swoich interesariuszy i ich cele organizacyjne.\n3. **Określ kategorie zdolności, aby zorganizować zdolności.**\n4. Określ zdolności potrzebne do osiągnięcia celów grupowych.",
  spec_cat: "Określ kategorie",
  spec_sh_instr:
    "1. Ustal cele grupowe, które chcesz osiągnąć.\n2. **Określ swoich interesariuszy i ich cele organizacyjne.**\n3. Określ kategorie zdolności, aby zorganizować zdolności.\n4. Określ zdolności potrzebne do osiągnięcia celów grupowych.",
  spec_sh: "Określ interesariuszy",
  start_time: "Czas rozpoczęcia",
  subcat: "Podkategoria",
  task_settings: "##### Ustawienia zadań",
  task: "Zadanie",
  task2perf: "##### Tabela przełożenia zadań na wydajność",
  tasks: "Zadania",
  ass_task_scale: "Skala zadań",
  ass_perf_scale: "Wydajność",
  taxonomy_route: "/taxonomy",
  taxonomy: "Taksonomia",
  tax_def:
    "#### Taksonomia\n\nDefinicje i skróty powszechnie używanych terminów.",
  TAXONOMY: {
    HAZARD: "Zagrożenie",
    HAZARD_DEF:
      "Proces, zjawisko lub działalność ludzka, która może spowodować utratę życia, obrażenia, zakłócenia lub szkody dla środowiska.",
    HAZARD_TYPE: "Typ zagrożenia",
    HAZARD_TYPE_DEF:
      "Klasa zagrożeń o podobnym pochodzeniu lub charakterystyce, takich jak zagrożenia naturalne, technologiczne lub wywołane przez człowieka.",
    DISASTER: "Katastrofa",
    DISASTER_DEF:
      "Poważne zakłócenie funkcjonowania społeczności lub społeczeństwa, przekraczające jego zdolność radzenia sobie własnymi zasobami.",
    EMERGENCY: "Sytuacja awaryjna",
    EMERGENCY_DEF:
      "Sytuacja wymagająca natychmiastowego skoordynowanego działania w celu ochrony życia, zdrowia, mienia lub środowiska.",
    DISASTER_RISK: "Ryzyko katastrofy",
    DISASTER_RISK_DEF:
      "Potencjał strat wynikających z niebezpiecznych zdarzeń, kształtowany przez zagrożenie, ekspozycję, podatność i zdolność.",
    EXPOSURE: "Ekspozycja",
    EXPOSURE_DEF:
      "Obecność ludzi, aktywów, infrastruktury i usług w miejscach, gdzie mogą wystąpić zagrożenia.",
    VULNERABILITY: "Podatność",
    VULNERABILITY_DEF:
      "Warunki zwiększające podatność ludzi, aktywów lub systemów na skutki zagrożeń.",
    CAPACITY: "Pojemność",
    CAPACITY_DEF:
      "Mocne strony i zasoby dostępne do przewidywania, radzenia sobie, opierania się i odzyskiwania po skutkach zagrożeń.",
    CAPABILITY: "Zdolność",
    CAPABILITY_DEF:
      "Specyficzna, demonstrowalna zdolność organizacji do wykonywania zadań i osiągania wyników w określonych warunkach.",
    RESILIENCE: "Odporność",
    RESILIENCE_DEF:
      "Zdolność systemów i społeczności do opierania się, absorbowania, adaptowania i odzyskiwania przy zachowaniu niezbędnych funkcji.",
    PREVENTION: "Zapobieganie",
    PREVENTION_DEF:
      "Działania mające na celu unikanie tworzenia nowych ryzyk i zapobieganie zagrożeniom przed powodowaniem szkodliwych skutków.",
    MITIGATION: "Łagodzenie",
    MITIGATION_DEF:
      "Środki zmniejszające nasilenie lub prawdopodobieństwo niekorzystnych skutków niebezpiecznych zdarzeń.",
    PREPAREDNESS: "Gotowość",
    PREPAREDNESS_DEF:
      "Wiedza, plany i zdolności rozwijane z wyprzedzeniem w celu umożliwienia skutecznego przewidywania, reagowania i odbudowy.",
    EARLY_WARNING_SYSTEM: "System wczesnego ostrzegania",
    EARLY_WARNING_SYSTEM_DEF:
      "Zintegrowany system monitorowania zagrożeń, oceny ryzyka, komunikowania ostrzeżeń i umożliwiania terminowych działań.",
    RESPONSE: "Reagowanie",
    RESPONSE_DEF:
      "Działania podejmowane tuż przed, w trakcie lub bezpośrednio po zdarzeniu w celu ratowania życia i zaspokajania pilnych potrzeb.",
    RECOVERY: "Odbudowa",
    RECOVERY_DEF:
      "Proces przywracania i poprawy środków do życia, usług, infrastruktury i systemów po katastrofie.",
    BUILD_BACK_BETTER: "Odbudowa lepsza niż wcześniej",
    BUILD_BACK_BETTER_DEF:
      "Wykorzystanie odbudowy i rekonstrukcji do zmniejszenia przyszłych ryzyk i poprawy odporności ponad stan sprzed katastrofy.",
    CONTINGENCY_PLANNING: "Planowanie awaryjne",
    CONTINGENCY_PLANNING_DEF:
      "Przygotowywanie konkretnych planów operacyjnych i ustaleń koordynacyjnych dla wiarygodnych scenariuszy awaryjnych.",
    RISK_ASSESSMENT: "Ocena ryzyka",
    RISK_ASSESSMENT_DEF:
      "Ustrukturyzowany proces identyfikowania zagrożeń, analizowania konsekwencji i szacowania ryzyka w celu wsparcia decyzji.",
    RISK_COMMUNICATION: "Komunikacja ryzyka",
    RISK_COMMUNICATION_DEF:
      "Dwukierunkowa wymiana informacji o ryzyku między władzami, reagującymi, interesariuszami i opinią publiczną.",
    SITUATION_AWARENESS: "Świadomość sytuacyjna",
    SITUATION_AWARENESS_DEF:
      "Aktualne i wspólne zrozumienie warunków incydentu, skutków, zasobów i prawdopodobnych wydarzeń.",
    INCIDENT_COMMAND: "Dowodzenie incydentem",
    INCIDENT_COMMAND_DEF:
      "Struktura dowodzenia i koordynacji do zarządzania rolami, decyzjami i zasobami podczas incydentów.",
    STAKEHOLDER: "Interesariusz",
    STAKEHOLDER_DEF:
      "Każda organizacja, grupa lub osoba pełniąca rolę, odpowiedzialność lub zainteresowana gotowością, reagowaniem lub odbudową.",
    INTEROPERABILITY: "Interoperacyjność",
    INTEROPERABILITY_DEF:
      "Zdolność organizacji, zespołów i systemów do efektywnej współpracy w zakresie procedur, danych i technologii.",
    CAPABILITY_GAP: "Luka zdolności",
    CAPABILITY_GAP_DEF:
      "Różnica między wymaganym a obecnym poziomem zdolności potrzebnym do osiągnięcia docelowych wyników.",
    CAPABILITY_ASSESSMENT: "Ocena zdolności",
    CAPABILITY_ASSESSMENT_DEF:
      "Ustrukturyzowana ocena ważności i wydajności zdolności w celu identyfikacji priorytetów poprawy.",
    SOLUTION: "Rozwiązanie",
    SOLUTION_DEF:
      "Środek, praktyka, technologia lub interwencja zaproponowana w celu rozwiązania jednej lub więcej luk zdolności.",
    SOLUTION_ASSESSMENT: "Ocena rozwiązań",
    SOLUTION_ASSESSMENT_DEF:
      "Systematyczna ocena kandydatów na rozwiązania pod kątem potrzeb użytkowników, przydatności operacyjnej, wpływu i zgodności.",
    ROADMAP: "Plan działania",
    ROADMAP_DEF:
      "Fazowy plan wdrożenia pokazujący, co zostanie dostarczone, przez kogo i kiedy.",
    IMPLEMENTATION_TIMELINE: "Harmonogram wdrożenia",
    IMPLEMENTATION_TIMELINE_DEF:
      "Planowana sekwencja i harmonogram działań, kamieni milowych i produktów do wdrożenia.",
    PRIORITIZATION: "Priorytetyzacja",
    PRIORITIZATION_DEF:
      "Klasyfikowanie działań lub inwestycji na podstawie pilności, oczekiwanego wpływu, wykonalności i dostępnych zasobów.",
    MONITORING_EVALUATION: "Monitorowanie i ocena",
    MONITORING_EVALUATION_DEF:
      "Bieżące śledzenie i okresowy przegląd postępów, wyników i skuteczności w celu wsparcia uczenia się i dostosowania.",
    LESSONS_LEARNED: "Wyciągnięte wnioski",
    LESSONS_LEARNED_DEF:
      "Udokumentowane spostrzeżenia z operacji i ćwiczeń wykorzystywane do poprawy przyszłego planowania i wydajności.",
    SESSION: "Sesja oceny",
    SESSION_DEF:
      "Zapisany kontekst pracy zawierający wybrane zagrożenia, oceny, rozwiązania i dane planu działania.",
    COMPLIANCE_CHECK: "Sprawdzenie zgodności",
    COMPLIANCE_CHECK_DEF:
      "Weryfikacja, że proponowane rozwiązania i działania spełniają wymogi prawne, polityczne, etyczne i sektorowe.",
    TECHNOLOGY_READINESS_LEVEL: "Poziom gotowości technologicznej",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Skala od 1 do 9 wskazująca dojrzałość technologii od koncepcji do wdrożenia operacyjnego.",
  },
  term: "Termin",
  title: "Tytuł",
  upload: "Prześlij",
  url: "URL",
  value: "Wartość",
  yes: "Tak",
  TBD: "Nieznane",
  general_settings: "Ogólne",
  enable_sol_ass_support: "Ocena rozwiązań włączona",
  logo: "Logo użytkownika",
  attribution_logo: "Logo atrybucji",
  attribution_text: "Tekst atrybucji",
  order: "Kolejność",
  hide: "Ukryj w przeglądzie",
  select_user: "Wybierz użytkownika",
  user: "Zwykły użytkownik",
  moderator: "Moderator",
  admin: "Administrator",
  doc_title: "Raport oceny zdolności",
  export_to_word: "Eksportuj do Word",
  export_all_to_word: "Eksportuj pełny raport do Word",
  add_gap: "Dodaj lukę zdolności",
  ignore: "Nie dotyczy",
  continue: "Kontynuuj",
  hazards: "Zagrożenia",
  hazards_route: "/hazards",
  hazard_step_title: "Krok 0: Inicjacja i Przygotowanie",
  hazard_step_desc:
    "Wybierz typy zagrożeń istotne dla zakresu, który chcesz omówić na tym warsztacie oceny.",
  workshop_scope: "Zakres warsztatu",
  hazard_category_all: "Wszystkie",
  hazard_category_natural: "Naturalne",
  hazard_category_technical: "Techniczne",
  hazard_category_attack: "Atak",
  hazard_edit: "Edytuj typy zagrożeń",
  hazard_done: "Zakończ edycję",
  hazard_add: "Dodaj nowy typ zagrożenia",
  hazard_name: "Nazwa zagrożenia",
  hazard_description: "Opis / kontekst",
  hazard_selected_count: "{n} typ(y/ów) zagrożenia wybrany/e.",
  solutions: "Rozwiązania",
  solution_count: {
    1: "1 rozwiązanie",
    n: "{n} rozwiązania/ń",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Krok 2: Ocena rozwiązań",
  solutions_step_desc: "Dodaj i oceń rozwiązania dla zidentyfikowanych luk.",
  solution_add: "Dodaj rozwiązanie",
  solution_new: "Nowe rozwiązanie",
  solution_gaps_found: {
    1: "1 luka zdolności zidentyfikowana",
    n: "{n} luki/luk zdolności zidentyfikowanych",
  },
  solution_empty:
    "Nie dodano jeszcze żadnych rozwiązań. Kliknij 'Dodaj rozwiązanie', aby rozpocząć.",
  roadmap: "Plan działania",
  roadmap_count: {
    1: "1 element planu działania",
    n: "{n} elementy/ów planu działania",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Krok 3: Plan działania",
  roadmap_step_desc: "Planuj harmonogramy wdrożenia i zobowiązania.",
  roadmap_add_solutions: "Dodaj {n} rozwiązanie/a do planu działania",
  roadmap_empty_solutions:
    "Najpierw ukończ krok 2 (Ocena rozwiązań), aby dodać rozwiązania do planu działania.",
  roadmap_empty: "Brak elementów w planie działania.",
  roadmap_timeline: "Harmonogram",
  session_create: "Utwórz",
  session_new_name: "Nazwa nowej sesji",
  session_sessions: "Sesje oceny",
  session_name: "Nazwa",
  session_updated: "Ostatnia aktualizacja",
  session_actions: "Działania",
  session_clone: "Klonuj sesję",
  session_download: "Pobierz jako JSON",
  session_delete: "Usuń sesję",
  session_import: "Importuj JSON",
  session_delete_confirm: "Usunąć sesję: {name}?",
  session_delete_warning: "Tej operacji nie można cofnąć. Czy jesteś pewien?",
  dashboard_subtitle:
    "Wykonaj poniższe kroki, aby ukończyć ocenę zarządzania kryzysowego.",
  back_to_sessions: "Powrót do sesji",
  step0_title: "Inicjacja i Przygotowanie",
  step1_title: "Ocena potrzeb i luk",
  step2_title: "Ocena rozwiązań",
  step3_title: "Plan działania",
  summary: "Podsumowanie",
  selected_hazards: "Wybrane zagrożenia",
  capability_gaps: "Luki zdolności",
  more: "więcej",
  partially: "Częściowo",
  not_assessed: "Nieocenione",
  enabled_steps: "Aktywne kroki",
  priority_low: "Niski",
  priority_medium: "Średni",
  priority_high: "Wysoki",
  sol_trl: "Poziom gotowości technologicznej",
  trl1: "Zaobserwowano podstawowe zasady",
  trl2: "Sformułowano koncepcję technologiczną",
  trl3: "Eksperymentalne potwierdzenie koncepcji",
  trl4: "Technologia zwalidowana w laboratorium",
  trl5: "Technologia zwalidowana w odpowiednim środowisku",
  trl6: "Technologia zademonstrowana w odpowiednim środowisku",
  trl7: "Prototyp systemu zademonstrowany w środowisku operacyjnym",
  trl8: "System kompletny i kwalifikowany",
  trl9: "Rzeczywisty system sprawdzony w środowisku operacyjnym",
  sol_integration_rl: "Poziom gotowości integracyjnej",
  sol_societal_rl: "Poziom gotowości społecznej",
  sol_manufacturing_rl: "Poziom gotowości produkcyjnej",
  sol_commercialisation_rl: "Poziom gotowości komercjalizacyjnej",
  sol_security_rl: "Poziom gotowości bezpieczeństwa",
  sol_legal_privacy_ethical_rl:
    "Poziom gotowości prawnej, prywatności i etycznej",
  integration_rl1: "Zidentyfikowano ogólną koncepcję integracji",
  integration_rl2:
    "Istnieje pewien poziom uszczegółowienia wymagań dotyczących interakcji komponentów",
  integration_rl3:
    "Szczegółowy projekt integracji został zdefiniowany i obejmuje wszystkie szczegóły interfejsu",
  integration_rl4:
    "Walidacja funkcji integrowanych komponentów w środowisku laboratoryjnym",
  integration_rl5:
    "Walidacja integrowanych komponentów w odpowiednim środowisku",
  integration_rl6:
    "Walidacja integrowanych komponentów w odpowiednim środowisku end-to-end",
  integration_rl7:
    "Demonstracja integracji prototypu w operacyjnym środowisku o wysokiej wierności",
  integration_rl8: "Test i demonstracja w środowisku operacyjnym",
  integration_rl9:
    "Potwierdzona integracja systemu poprzez pomyślne zdolności operacyjne podczas misji",
  societal_rl1:
    "Identyfikacja ogólnej potrzeby społecznej, dobra społecznego i powiązanych aspektów",
  societal_rl2:
    "Sformułowanie proponowanej koncepcji rozwiązania i potencjalnych oddziaływań",
  societal_rl3:
    "Ograniczona grupa społeczeństwa zna rozwiązanie lub podobne inicjatywy",
  societal_rl4:
    "Ograniczona grupa społeczeństwa testuje rozwiązanie lub podobne inicjatywy",
  societal_rl5:
    "Społeczeństwo zna rozwiązanie lub podobne inicjatywy, ale nie jest świadome ich korzyści",
  societal_rl6:
    "Społeczeństwo zna rozwiązanie, a świadomość jego korzyści wzrasta",
  societal_rl7:
    "Społeczeństwo jest w pełni świadome korzyści wynikających z rozwiązania",
  societal_rl8:
    "Społeczeństwo jest gotowe do przyjęcia rozwiązania i korzystało z podobnych rozwiązań na rynku",
  societal_rl9:
    "Społeczeństwo korzysta z rozwiązania, a rozwiązanie jest wspierane przez interesariuszy i opinię publiczną",
  manufacturing_rl1: "Zidentyfikowano podstawowe implikacje produkcyjne",
  manufacturing_rl2: "Zidentyfikowano koncepcje produkcyjne",
  manufacturing_rl3: "Opracowano produkcyjny dowód słuszności koncepcji",
  manufacturing_rl4:
    "Zdolność do wytwarzania technologii w środowisku laboratoryjnym",
  manufacturing_rl5:
    "Zdolność do wytwarzania komponentów prototypowych w środowisku istotnym dla produkcji",
  manufacturing_rl6:
    "Zdolność do wytwarzania prototypu systemu lub podsystemu w środowisku istotnym dla produkcji",
  manufacturing_rl7:
    "Zdolność do wytwarzania systemów, podsystemów lub komponentów w środowisku reprezentatywnym dla produkcji",
  manufacturing_rl8:
    "Zademonstrowano zdolność linii pilotażowej. Gotowość do rozpoczęcia produkcji niskoseryjnej",
  manufacturing_rl9:
    "Zademonstrowano produkcję niskoseryjną. Istnieje zdolność do rozpoczęcia produkcji pełnoseryjnej",
  commercialisation_rl1: "Badania i hipoteza bazowa",
  commercialisation_rl2: "Ocena rynku",
  commercialisation_rl3: "Walidacja zastosowania technologii i rynku",
  commercialisation_rl4: "Propozycja wartości",
  commercialisation_rl5: "Rozwój produktu i dopasowanie do rynku",
  commercialisation_rl6:
    "Optymalizacja produktu/rozwiązania i ochrona własności intelektualnej",
  commercialisation_rl7: "Walidacja techniczna i komercyjna",
  commercialisation_rl8: "Strategia komercjalizacji i wprowadzenie na rynek",
  commercialisation_rl9: "Pełne uruchomienie i przychody licencyjne",
  security_rl1: "Rozważenie bezpieczeństwa",
  security_rl2: "Rozwój koncepcji bezpieczeństwa",
  security_rl3: "Bezpieczeństwo wbudowane w projekt",
  security_rl4: "Przygotowanie środków i funkcji bezpieczeństwa",
  security_rl5: "Prosta walidacja bezpieczeństwa",
  security_rl6: "Sekwencyjna demonstracja bezpieczeństwa",
  security_rl7: "Złożone demonstracje bezpieczeństwa",
  security_rl8:
    "Końcowa walidacja bezpieczeństwa przed wydaniem i przygotowanie",
  security_rl9: "Początkowe bezpieczeństwo operacyjne",
  security_rl10: "Dobrze ugruntowane/niezawodne bezpieczeństwo",
  legal_privacy_ethical_rl1:
    "Kontrola kwestii prawnych, etycznych i prywatności: system wdrożył mechanizmy kontroli odpowiedzialności oraz przeszedł standardowe benchmarki i uzyskał certyfikację, jeśli dotyczy",
  legal_privacy_ethical_rl2:
    "Napięcia etyczne rozwiązane poprzez ethics-by-design: prawne, etyczne i prywatnościowe aspekty systemu zostały zaprojektowane tak, aby były ze sobą zgodne. Napięcia etyczne zostały rozwiązane, co oznacza, że poprawa jednego aspektu nie wpływa negatywnie na inny",
  legal_privacy_ethical_rl3:
    "Scharakteryzowane interakcje prawne, etyczne i prywatnościowe: scharakteryzowano interakcje między różnymi aspektami etycznymi i prywatnościowymi",
  legal_privacy_ethical_rl4:
    "Zidentyfikowane kwestie prawne, etyczne i prywatnościowe: zidentyfikowano i przewidziano kwestie etyczne i prywatnościowe podnoszone przez system",
  sol_linked_caps: "Powiązane zdolności (z lukami)",
  sol_addressed_gaps: "Zaadresowane luki zdolności",
  sol_no_gaps:
    "Nie zidentyfikowano jeszcze żadnych luk zdolności. Przejdź do Kroku 1, aby ocenić zdolności.",
  sol_compliance_title: "Sprawdzenia zgodności",
  sol_status: "Status",
  sol_pass: "Zgodny",
  sol_partial: "Częściowy",
  sol_fail: "Niezgodny",
  sol_na: "N/D",
  sol_not_applicable: "Nie dotyczy",
  sol_user_needs_title: "Ocena potrzeb użytkowników",
  sol_operational_needs_title: "Ocena potrzeb operacyjnych",
  sol_organisational_needs_title: "Ocena potrzeb organizacyjnych",
  sol_expected_impact_title: "Ocena oczekiwanego wpływu",
  sol_question: "Pytanie",
  sol_response: "Odpowiedź",
  UN01: "Czy rozwiązanie jest łatwe w użyciu?",
  UN02: "Czy rozwiązanie prawdopodobnie działa odpowiednio pod presją? Wliczając odporność i niezawodność.",
  UN03: "Czy rozwiązanie zostanie prawdopodobnie zaakceptowane przez użytkowników?",
  UN04: "Czy rozwiązanie prawdopodobnie wspiera zrozumiałość dla użytkowników?",
  UN05: "Czy rozwiązanie prawdopodobnie wspiera wyjaśnialność dla użytkowników?",
  UN06: "Czy rozwiązanie prawdopodobnie poprawi efektywność użytkowników?",
  UN07: "Czy rozwiązanie prawdopodobnie poprawi skuteczność użytkowników?",
  UN08: "Czy rozwiązanie prawdopodobnie dostarczy dodatkowej wiedzy?",
  UN09: "Czy rozwiązanie prawdopodobnie konsekwentnie będzie generować pozytywne interwencje i/lub wyniki?",
  ON01: "Czy rozwiązanie prawdopodobnie wymaga obszernego (po-)szkolenia?",
  ON02: "Czy rozwiązanie prawdopodobnie wymaga nadmiernej konserwacji i wsparcia?",
  ON03: "Czy rozwiązanie prawdopodobnie jest zgodne z Twoimi metodami operacyjnymi/SOP?",
  ON04: "Czy rozwiązanie jest interoperacyjne?",
  ON05: "Czy rozwiązanie prawdopodobnie jest adaptowalne i transferowalne w Twoich scenariuszach operacyjnych?",
  ON06: "Czy rozwiązanie prawdopodobnie wspiera zdrowie i bezpieczeństwo ratowników?",
  ON07: "Czy rozwiązanie prawdopodobnie dotrze do zamierzonej grupy docelowej?",
  ON08: "Czy rozwiązanie prawdopodobnie oferuje lepszą efektywność operacyjną?",
  ON09: "Czy rozwiązanie prawdopodobnie oferuje lepszą skuteczność operacyjną?",
  OG01: "Czy rozwiązanie prawdopodobnie ma pozytywny bilans kosztów i korzyści?",
  OG02: "Czy rozwiązanie wydaje się wykonalne? Wliczając technologicznie, ekonomicznie, prawnie, operacyjnie i harmonogramowo.",
  OG03: "Czy rozwiązanie prawdopodobnie jest zgodne z kulturą organizacyjną?",
  OG04: "Czy rozwiązanie prawdopodobnie jest zgodne z mandatem organizacyjnym?",
  OG05: "Czy rozwiązanie prawdopodobnie jest zgodne z priorytetami zarządzania kryzysowego?",
  OG06: "Czy użycie rozwiązania wspierałoby Twoją reputację wśród społeczeństwa?",
  OG07: "Czy użycie rozwiązania pomogłoby w poprawie relacji ze społecznością?",
  EI01: "Czy rozwiązanie będzie stosowane w kontekście opieki zdrowotnej?",
  EI02: "Czy rozwiązanie obejmuje przetwarzanie danych osobowych?",
  EI03: "Czy rozwiązanie prawdopodobnie będzie miało negatywny wpływ na prawa i wolności jednostek i grup? Np. prywatność, godność, autonomia, solidarność.",
  EI04: "Czy rozwiązanie prawdopodobnie będzie miało negatywny wpływ w zakresie sprawiedliwości społecznej i równości?",
  EI05: "Czy rozwiązanie prawdopodobnie będzie miało negatywny wpływ na dobrostan jednostek lub grup?",
  EI06: "Czy rozwiązanie prawdopodobnie zwiększy podatność jednostek lub grup?",
  EI07: "Czy rozwiązanie prawdopodobnie stwarza potencjalne zagrożenia bezpieczeństwa?",
  EI08: "Czy rozwiązanie prawdopodobnie będzie miało negatywny wpływ na środowisko?",
  EI09: "Czy istnieje ZNACZĄCA niepewność co do prawnych, etycznych i społecznych skutków użycia rozwiązania?",
  CC01: "Bezpieczeństwo (cybernetyczne)",
  CC02: "Interoperacyjność",
  CC03: "Ustawa o AI",
  CC04: "Zaangażowanie społeczności",
  CC05: "RODO",
  CC06: "Prawa podstawowe",
  CC07: "Cele zrównoważonego rozwoju",
  CC08: "Krajowe priorytety zarządzania kryzysowego",
  CC09: "Normy branżowe",
  CC10: "Przepisy i regulacje branżowe",
  cap_add_from_ref: "Dodaj zdolności z referencji",
  cap_all_selected:
    "Wszystkie zdolności referencyjne zostały dodane do Twojej sesji.",
  cap_add_selected: "Dodaj wybrane zdolności",
  cap_ref_panel_title: "Dostępne zdolności (model referencyjny DASF)",
  collapse: "Zwiń",
  step0_abbr: "Krok 0: I&P",
  step0_desc: "Identyfikacja istotnych typów zagrożeń dla kontekstu oceny.",
  step1_abbr: "Krok 1: OPL",
  step1_desc: "Ocena zdolności, identyfikacja luk i potrzeb poprawy.",
  step2_abbr: "Krok 2: OR",
  step2_desc: "Ocena rozwiązań dla zidentyfikowanych luk zdolności.",
  step3_abbr: "Krok 3: PD",
  step3_desc: "Planowanie harmonogramu wdrożenia i zobowiązań.",
  landing_attribution:
    "DIREKTION otrzymał dofinansowanie z programu badań i innowacji Horyzont Europa Unii Europejskiej na podstawie umowy o dofinansowanie nr 101121249.",
  landing_developed_by: "Opracowane przez",
  landing_as_part_of: "w ramach",
  landing_project: "projektu.",
  dasf_purpose_title: "Cel DASF",
  dasf_purpose_p1:
    "DIREKTION Assessment and Screening Framework (DASF) to podstawowa metoda opracowana w ramach projektu DIREKTION, mająca na celu wspieranie przejrzystego i bezstronnego procesu selekcji i oceny.",
  dasf_purpose_offers: "Framework DASF oferuje metodę krok po kroku, aby:",
  dasf_purpose_item1: "Identyfikować i niwelować luki w zdolnościach",
  dasf_purpose_item2: "Wdrożyć systematyczną selekcję technologii i rozwiązań",
  dasf_purpose_item3: "Opracować plan działania",
  dasf_purpose_p2:
    "DASF stanowi podstawę trwałego procesu programowania badań, zapewniając, że osoby reagujące i interesariusze mają dostęp do najbardziej efektywnych i aktualnych narzędzi do gotowości i reagowania na katastrofy. Kompletny zestaw ma być wykonywany regularnie — na przykład raz w roku lub raz na cztery lata — aby uzyskać zaktualizowany wgląd w najbardziej aktualne potrzeby w zakresie zdolności, luki w zdolnościach, potencjalne rozwiązania i regularnie aktualizować plan działania dla unijnych lub krajowych możliwości badawczych.",
  landing_assessment_process: "Proces oceny",
  landing_video_tutorial: "Obejrzyj samouczek wideo na YouTube",
  landing_funded_by: "Finansowane przez Unię Europejską",
  landing_trilateral_attribution:
    "Do stworzenia tego narzędzia wykorzystano istotny wkład firmy Trilateral Research, opracowany w ramach DIREKTION D1.2.",
  delete_session_confirm: "Usunąć sesję: {name}?",
  delete_session_warning: "Tej operacji nie można cofnąć. Czy jesteś pewien?",
  N01: "Trzęsienie ziemi",
  N02: "Tsunami",
  N03: "Erupcja wulkanu",
  N04: "Osuwisko / Lawina",
  N05: "Powódź",
  N06: "Gwałtowna powódź",
  N07: "Burza / Huragan / Tornado",
  N08: "Pożar lasu",
  N09: "Ekstremalna temperatura (upał/mróz)",
  N10: "Susza",
  N11: "Epidemia / Pandemia",
  N12: "Wybuch choroby zwierząt",
  N13: "Inwazja owadów",
  T01: "Wypadek przemysłowy (CBRN)",
  T02: "Incydent jądrowy / Radiologiczny",
  T03: "Wypadek transportowy (lotniczy)",
  T04: "Wypadek transportowy (kolejowy)",
  T05: "Wypadek transportowy (drogowy)",
  T06: "Wypadek transportowy (morski)",
  T07: "Rurociąg / Wybuch gazu",
  T08: "Zawalenie budynku / Konstrukcji",
  T09: "Awaria tamy / Wału",
  T10: "Przerwa w dostawie prądu / Awaria sieci",
  T11: "Awaria telekomunikacji",
  T12: "Skażenie wody pitnej",
  T13: "Wyciek materiałów niebezpiecznych",
  A01: "Atak terrorystyczny (materiały wybuchowe)",
  A02: "Atak terrorystyczny (CBRN)",
  A03: "Atak cybernetyczny",
  A04: "Strzelec aktywny / Napaść zbrojna",
  A05: "Sabotaż infrastruktury krytycznej",
  A06: "Zakładnicy / Porwanie",
  A07: "Zamieszki cywilne / Rozruchy",
  A08: "Piractwo morskie / Porwanie statku",
  A09: "Atak dronem",
  A10: "Zagrożenie hybrydowe",
  A11: "Kampania dezinformacyjna",
  A12: "Zakłócenie łańcucha dostaw (umyślne)",
  A13: "Podpalenie",
  "Cat-01": "Łagodzenie / Zapobieganie",
  "Cat-02": "Gotowość",
  "Cat-03": "Reagowanie",
  "Cat-04": "Odbudowa",
  "Mit-01": "Ocena ryzyka",
  "Mit-02": "Redukcja ekspozycji",
  "Mit-03": "Wsparcie łagodzenia",
  "Prep-01": "Rozwój zdolności",
  "Prep-02": "Monitorowanie",
  "Prep-03": "Wsparcie gotowości",
  "Rsp-01": "Tłumienie incydentu",
  "Rsp-02": "Operacje ratownicze",
  "Rsp-03": "Bezpieczeństwo / Egzekwowanie prawa",
  "Rsp-04": "Ratownictwo medyczne",
  "Rsp-05": "Komunikacja ze społeczeństwem",
  "Rsp-06": "Ochrona ludności / zwierząt",
  "Rsp-07": "Oczyszczanie obszaru katastrofy",
  "Rsp-08": "Zaopatrzenie w podstawowe potrzeby",
  "Rsp-09": "Wsparcie reagowania",
  "Rec-01": "Odbudowa humanitarna",
  "Rec-02": "Odbudowa środowiska",
  "Rec-03": "Odbudowa gospodarcza",
  "Rec-04": "Przywrócenie infrastruktury",
  "Rec-05": "Wsparcie odbudowy",
  "Mit-RA-01": "Identyfikacja ryzyka",
  "Mit-RA-02": "Analiza ryzyka",
  "Mit-RA-03": "Ocena ryzyka",
  "Mit-ER-01": "Ochrona mienia",
  "Mit-ER-02": "Ochrona zasobów naturalnych",
  "Mit-ER-03": "Podnoszenie świadomości",
  "Mit-MS-01": "Analiza trendów",
  "Mit-MS-02": "Monitorowanie i przegląd",
  "Prep-CD-01": "Planowanie reagowania i odbudowy",
  "Prep-CD-02": "Szkolenie",
  "Prep-CD-03": "Komunikacja ryzyka",
  "Prep-MO-01": "Wykrywanie",
  "Prep-MO-02": "Alarmowanie",
  "Prep-PS-01": "Zarządzanie personelem",
  "Prep-PS-02": "Zarządzanie zasobami",
  "Prep-PS-03": "Nawiązywanie współpracy",
  "Prep-EH-04": "Opieka psychologiczna",
  "Resp-SI-01": "Gaszenie pożarów - Infrastruktury",
  "Resp-SI-02": "Gaszenie pożarów - Przyroda",
  "Resp-SI-03": "Kontrola powodzi",
  "Resp-SI04": "Kontrola materiałów niebezpiecznych (CBRN-E)",
  "Resp-RO-01": "Poszukiwanie i ratownictwo (SAR)",
  "Resp-RO-02": "Leczenie ofiar na miejscu",
  "Resp-RO-03": "Transport ofiar",
  "Resp-SL-01": "Zabezpieczanie miejsc / osób",
  "Resp-SL-02": "Identyfikacja osób",
  "Resp-SL-03": "Kryminalistyka",
  "Resp-SL-04": "Utrzymanie porządku publicznego",
  "Resp-SL-05": "Zarządzanie ruchem",
  "Resp-EH-01": "Pilna opieka - Szpitale",
  "Resp-EH-02": "Kwarantanna",
  "Resp-EH-03": "Masowe zdrowie publiczne",
  "Resp-CS-01": "Ostrzeganie",
  "Resp-CS-02": "Komunikacja kryzysowa",
  "Resp-SF-01": "Ewakuacja",
  "Resp-SF-02": "Schronienie",
  "Resp-SF-03": "Ponowne połączenie rodzin",
  "Resp-DA-01": "Usuwanie gruzu",
  "Resp-DA-02": "Dekontaminacja obiektów",
  "Resp-DA-03": "Odwadnianie",
  "Resp-DA-04": "Niszczenie zwierząt",
  "Resp-BN-01": "Zaopatrzenie w wodę pitną",
  "Resp-BN-02": "Zaopatrzenie w żywność",
  "Resp-BN-03": "Zaopatrzenie w energię",
  "Resp-BN-04": "Zapewnienie ICT / Telekomunikacji",
  "Resp-BN-05": "Zapewnienie sanitacji",
  "Resp-RS-01": "Dowodzenie, Kontrola i Koordynacja",
  "Resp-RS-02": "Ocena sytuacji",
  "Resp-RS-03": "Zarządzanie informacją",
  "Resp-RS-04": "Monitorowanie / Zbieranie danych",
  "Resp-RS-05": "Wsparcie operacji na miejscu",
  "Resp-RS-06": "Logistyka",
  "Rec-HR-01": "Zdrowie publiczne i bezpieczeństwo",
  "Rec-HR-02": "Żywność i schronienie",
  "Rec-ER-01": "Zarządzanie odpadami",
  "Rec-ER-02": "Przywrócenie siedlisk",
  "Rec-EC-01": "Odbudowa gospodarcza",
  "Rec-EC-02": "Odbudowa finansowa",
  "Rec-RI-01": "Przywrócenie transportu",
  "Rec-RI-02": "Przywrócenie mediów",
  "Rec-RS-01": "Ustanowienie organizacji odbudowy",
  "Rec-RS-02": "Programowanie odbudowy",
  "Goal-01": "Zapobieganie incydentom",
  "Goal-01_desc": "Zapobieganie katastrofom / sytuacjom kryzysowym.",
  "Goal-02": "Minimalizacja strat wynikających z zagrożeń",
  "Goal-02_desc": "Zmniejszanie / unikanie strat wynikających z zagrożeń.",
  "Goal-03": "Pomoc ofiarom",
  "Goal-03_desc": "Zapewnienie szybkiej i skutecznej pomocy ofiarom.",
  "Goal-04": "Odpowiednia odbudowa",
  "Goal-04_desc": "Osiągnięcie szybkiej i skutecznej odbudowy.",
  "TO-01": "Straż pożarna / Ochrona cywilna",
  "TO-02": "Policja",
  "TO-03": "Ratownictwo medyczne",
  "TO-04": "Obrona",
  "TO-05": "Centrum dowodzenia",
  "TO-06": "Władze",
  "TO-07": "Infrastruktura krytyczna",
  "TO-08": "NGO",
  "TO-09": "Inne",
  "SH-01": "Straż pożarna/Ochrona cywilna",
  "SH-02": "Policja",
  "SH-03": "Ratownictwo medyczne",
  "SH-04": "SAR",
  "SH-05": "Centrum dowodzenia lub dyspozytura (112)",
  "SH-06": "Władze (ministerstwa, gminy)",
  "SH-07": "Obrona",
  "SH-08": "Służby publiczne",
  "SH-09": "Straż przybrzeżna lub Ochrona granic",
  "SH-10": "Operator infrastruktury krytycznej",
  "SH-11": "NGO",
  "SH-12": "Inne (do opisania)",
  "Imp-1": "Brak/Bardzo niskie",
  "Imp-2": "Niskie",
  "Imp-3": "Średnie",
  "Imp-4": "Dość wysokie",
  "Imp-5": "Bardzo wysokie",
  "PA-1": "Skuteczność",
  "PA-1_desc": "Jakość wyników, terminowość, wytrzymałość.",
  "PA-2": "Bezpieczeństwo/Ochrona profesjonalistów",
  "PA-2_desc": "Fizyczne i psychiczne bezpieczeństwo zaangażowanego personelu.",
  "PA-3": "Efektywność",
  "PA-3_desc": "Relacja między kosztami a wynikami.",
  "PSc-1": "Słaba",
  "PSc-2": "Niezadowalająca",
  "PSc-3": "Umiarkowana",
  "PSc-4": "Zadowalająca",
  "PSc-5": "Dobra",
  "Nat-01": "Technologiczny",
  "Nat-01_desc":
    "Np. Technologie sensoryczne, dowodzenie i kontrola, komunikacja i koordynacja, ICT.",
  "Nat-02": "Ludzki",
  "Nat-02_desc":
    "Np. Ilość personelu, kompetencje personelu, szkolenie i edukacja.",
  "Nat-03": "Organizacyjny",
  "Nat-03_desc":
    "Np. Procedury, struktura organizacyjna, aspekty finansowe, umowy.",
  "Nat-04": "Regulacyjny",
  "Nat-04_desc": "Np. Aspekty prawne, formalne aspekty normalizacji.",
  "Kn-01": "Nieznane",
  "Kn-02": "Nie",
  "Kn-03": "Tak",
  "ASc-01": "Bardzo niskie",
  "ASc-02": "Niskie",
  "ASc-03": "Umiarkowane",
  "ASc-04": "Wysokie",
  "ASc-05": "Bardzo wysokie",
  "Cat-01_desc":
    "Cel: Podjąć środki w celu ograniczenia prawdopodobieństwa i zmniejszenia skutków incydentu, katastrofy lub kryzysu.",
  "Cat-02_desc":
    "Cel: Rozwijać i utrzymywać strukturę organizacyjną i zdolności do prowadzenia działań reagowania i odbudowy.",
  "Cat-03_desc": "Cel: Ratować życie i ograniczać negatywne skutki.",
  "Cat-04_desc":
    "Cel: Odbudować i przywrócić normalne życie w efektywny sposób.",
  "Mit-01_desc": "Identyfikacja, analiza i ocena ryzyk.",
  "Mit-02_desc":
    "Ochrona mienia, zasobów naturalnych i społeczeństwa przed zagrożeniami.",
  "Mit-03_desc": "Zdolności wspierające łagodzenie / zapobieganie.",
  "Prep-01_desc":
    "Proces rozwijania i utrzymywania wymaganych zdolności zarządzania kryzysowego.",
  "Prep-02_desc":
    "Określanie stanu środowiska lub sytuacji w celu umożliwienia wykrywania incydentów.",
  "Prep-03_desc": "Zdolności wspierające rozwój zdolności.",
  "Rsp-01_desc":
    "Działania na miejscu w celu zatrzymania lub opanowania przyczyny katastrofy.",
  "Rsp-02_desc": "Działania na miejscu w celu ratowania życia.",
  "Rsp-03_desc":
    "Zabezpieczanie obszarów/osób, identyfikacja osób, kryminalistyka.",
  "Rsp-04_desc": "Działania poza miejscem w celu ratowania życia.",
  "Rsp-05_desc": "Ostrzeganie i komunikacja kryzysowa.",
  "Rsp-06_desc": "Kontrolowana ewakuacja osób i/lub zwierząt.",
  "Rsp-07_desc":
    "Zapewnienie dostępności i bezpieczeństwa na obszarze dotkniętym katastrofą.",
  "Rsp-08_desc":
    "Dostawa i/lub przywrócenie podstawowych produktów i usług o kluczowym znaczeniu.",
  "Rsp-09_desc":
    "Zdolności umożliwiające jedną lub więcej innych zdolności reagowania.",
  "Rec-01_desc":
    "Zapewnienie usług zdrowia publicznego, bezpieczeństwa i schronienia.",
  "Rec-02_desc": "Usuwanie zanieczyszczeń i dekontaminacja.",
  "Rec-03_desc": "Odbudowa gospodarcza i biznesowa.",
  "Rec-04_desc": "Przywrócenie tras transportowych i niezbędnych usług.",
  "Rec-05_desc": "Zdolności wymagane do dobrze skoordynowanej odbudowy.",
  "Mit-RA-01_desc": "Proces wyszukiwania, rozpoznawania i opisywania ryzyka.",
  "Mit-RA-02_desc":
    "Proces rozumienia natury ryzyka i określania poziomu ryzyka.",
  "Mit-RA-03_desc":
    "Proces porównywania wyników analizy ryzyka z kryteriami ryzyka w celu określenia, czy ryzyko jest akceptowalne lub tolerowalne.",
  "Mit-ER-01_desc": "Ochrona mienia (w tym infrastruktury krytycznej).",
  "Mit-ER-02_desc":
    "Działania minimalizujące straty wynikające z zagrożeń i zachowujące lub przywracające funkcje naturalnych systemów.",
  "Mit-ER-03_desc":
    "Publiczna edukacja i podnoszenie świadomości na temat zagrożeń i potencjalnych sposobów ich łagodzenia.",
  "Mit-MS-01_desc": "Badanie ewolucji ryzyk.",
  "Mit-MS-02_desc":
    "Zapewnienie skuteczności i efektywności kontroli oraz uzyskanie dalszych informacji w celu poprawy oceny ryzyka.",
  "Prep-CD-01_desc":
    "Opracowywanie, kompilowanie i utrzymywanie procedur i informacji gotowych do użycia podczas incydentu.",
  "Prep-CD-02_desc":
    "Działania ułatwiające uczenie się i rozwijanie wiedzy, umiejętności i zdolności do reagowania na katastrofy.",
  "Prep-CD-03_desc":
    "Komunikowanie i instruowanie społeczeństwa, jak być dobrze przygotowanym na kryzys i jak zachowywać się, gdy on nastąpi.",
  "Prep-MO-01_desc": "Wykrywanie okoliczności odbiegających od normy.",
  "Prep-MO-02_desc":
    "Alarmowanie personelu o obecności incydentu i inicjowanie działań kontrolnych.",
  "Prep-PS-01_desc":
    "Działania mające na celu zapewnienie wystarczającego i wykwalifikowanego personelu do wykonywania zadań reagowania i odbudowy.",
  "Prep-PS-02_desc":
    "Działania mające na celu zapewnienie wyposażenia, narzędzi, ICT i innych zasobów niezbędnych do reagowania i odbudowy.",
  "Prep-PS-03_desc":
    "Ustanowienie międzynarodowej współpracy między służbami ratowniczymi a stronami trzecimi.",
  "Prep-EH-04_desc":
    "Opieka zdrowotna psychologiczna dla ofiar, krewnych i innych osób dotkniętych incydentem.",
  "Resp-SI-01_desc":
    "Gaszenie pożarów w budynkach, zabudowanych obszarach lub infrastrukturach.",
  "Resp-SI-02_desc": "Gaszenie pożarów w naturalnym środowisku.",
  "Resp-SI-03_desc":
    "Zarządzanie wodą w przypadku powodzi spowodowanej przerwaniem wału lub intensywnymi opadami.",
  "Resp-SI04_desc":
    "Zatrzymanie wycieku materiałów niebezpiecznych, w tym ograniczenie (incydenty CBRN-E).",
  "Resp-RO-01_desc": "Operacje poszukiwawczo-ratownicze.",
  "Resp-RO-02_desc": "Triage, dekontaminacja i stabilizacja ofiar.",
  "Resp-RO-03_desc": "Transport karetką do bezpiecznych obszarów lub szpitali.",
  "Resp-SL-01_desc":
    "Ochrona obszarów, infrastruktury i osób przed osobami niezaangażowanymi.",
  "Resp-SL-02_desc": "Identyfikacja ofiar.",
  "Resp-SL-03_desc":
    "Działania kryminalistyczne mające na celu zbadanie przyczyny incydentu i zabezpieczenie dowodów.",
  "Resp-SL-04_desc": "Kontrola zamieszek itp.",
  "Resp-SL-05_desc":
    "Kontrola ruchu wchodzącego i wychodzącego z obszaru dotkniętego katastrofą.",
  "Resp-EH-01_desc": "Służba zdrowia w regularnych i/lub polowych szpitalach.",
  "Resp-EH-02_desc": "Izolacja potencjalnie zakaźnych osób/ofiar.",
  "Resp-EH-03_desc":
    "Masowa profilaktyka lub szczepienia w przypadku incydentu jądrowego lub pandemii.",
  "Resp-CS-01_desc":
    "Ostrzeganie społeczeństwa w strefie zagrożenia poprzez dostarczanie terminowych i odpowiednich informacji o zagrożeniu.",
  "Resp-CS-02_desc":
    "Dostarczanie informacji o katastrofie społeczeństwu, w tym zarządzanie wolontariuszami i apele.",
  "Resp-SF-01_desc":
    "Kontrolowana ewakuacja osób i zwierząt z określonego obszaru lub budynku.",
  "Resp-SF-02_desc":
    "Zapewnienie schronienia ewakuowanym, w tym wyżywienie i sanitacja.",
  "Resp-SF-03_desc": "Ponowne połączenie ewakuowanych z ich krewnymi.",
  "Resp-DA-01_desc": "Usuwanie gruzu i/lub skażonego materiału.",
  "Resp-DA-02_desc":
    "Dekontaminacja skażonych obszarów, infrastruktury i/lub pojazdów.",
  "Resp-DA-03_desc":
    "Odwadnianie i pompowanie zalanych obszarów lub infrastruktury.",
  "Resp-DA-04_desc": "Niszczenie potencjalnie zainfekowanych zwierząt.",
  "Resp-BN-01_desc": "Przywrócenie lub tymczasowe zapewnienie wody pitnej.",
  "Resp-BN-02_desc": "Tymczasowe zapewnienie żywności.",
  "Resp-BN-03_desc":
    "Przywrócenie dostaw energii elektrycznej/gazu lub zapewnienie tymczasowej alternatywnej energii.",
  "Resp-BN-04_desc":
    "Przywrócenie lub tymczasowe zapewnienie ICT i telekomunikacji.",
  "Resp-BN-05_desc":
    "Przywrócenie sanitacji lub zapewnienie tymczasowych rozwiązań.",
  "Resp-RS-01_desc":
    "Podejmowanie decyzji, planowanie i wyznaczanie zadań na poziomach koordynacji i dowodzenia podczas zarządzania katastrofą.",
  "Resp-RS-02_desc":
    "Opracowywanie informacji operacyjnych poprzez wzbogacanie zebranych danych, w tym wspólny obraz operacyjny.",
  "Resp-RS-03_desc":
    "Przechowywanie i udostępnianie informacji, takich jak zebrane dane, oceny i podjęte decyzje.",
  "Resp-RS-04_desc":
    "Zbieranie danych poprzez fizyczne monitorowanie (obserwację) i eksplorację danych.",
  "Resp-RS-05_desc":
    "Zapewnienie podstawowych usług dla ratowników na miejscu w celu umożliwienia działań reagowania.",
  "Resp-RS-06_desc":
    "Transport personelu i sprzętu w celu wsparcia długotrwałych operacji reagowania na katastrofy.",
  "Rec-HR-01_desc":
    "Zapewnienie usług zdrowia publicznego i bezpieczeństwa dla przesiedlonych.",
  "Rec-HR-02_desc": "Zapewnienie żywności i schronienia dla przesiedlonych.",
  "Rec-ER-01_desc":
    "Usuwanie zanieczyszczeń na dużą skalę i dekontaminacja oraz gospodarka odpadami.",
  "Rec-ER-02_desc": "Przywrócenie zasobów naturalnych i siedlisk.",
  "Rec-EC-01_desc":
    "Odbudowa gospodarcza sklepów i przemysłu poszkodowanych w wyniku katastrofy.",
  "Rec-EC-02_desc": "Odbudowa po finansowych skutkach dla władz.",
  "Rec-RI-01_desc":
    "Przywrócenie tras transportowych (drogowych, kolejowych, wodnych, lotniczych, rurociągów).",
  "Rec-RI-02_desc":
    "Przywrócenie przerwanej infrastruktury i innych niezbędnych usług.",
  "Rec-RS-01_desc":
    "Ustanowienie struktury organizacyjnej odbudowy zarówno dla krótkoterminowej, jak i długoterminowej odbudowy.",
  "Rec-RS-02_desc":
    "Określenie i wdrożenie programu odbudowy na podstawie oceny skutków.",
  manage_capabilities: "Wybierz zdolności",
  select_capabilities_instr:
    "Wybierz zdolności, które chcesz ocenić pod kątem luk.",
  drawer_hazards: "Zagrożenia",
  drawer_gaps: "Luki",
  drawer_solutions: "Rozwiązania",
  drawer_roadmap: "Plan działania",
  drawer_capabilities: "Zdolności",
  drawer_solution: "Rozwiązanie",
  drawer_with_gaps: "z lukami",
  drawer_no_linked_caps: "Brak powiązanych zdolności",
  drawer_add_to_roadmap: "Dodaj do planu działania →",
  drawer_go_to_solutions: "Przejdź do rozwiązań →",
  drawer_go_to_roadmap: "Przejdź do planu działania →",
  drawer_none: "Brak",
  drawer_relevant_hazards: "Istotne zagrożenia",
  action_priority: "Priorytet działania",
  action_priority_instr:
    "Oceń swoją gotowość do działania na rzecz poprawy tej zdolności (1 = niska, 5 = pilna)",
  action_priority_label_1: "Nie teraz",
  action_priority_label_3: "Może",
  action_priority_label_5: "Pilne",
  prev_cap: "Poprzedni",
  next_cap: "Następny",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

Zestaw narzędzi DASF wspomaga systematyczny proces oceny i przesiewu dla zarządzania katastrofami. Oferuje ustrukturyzowane podejście w 4 krokach:

1. **Inicjacja i Przygotowanie (I&P)**: Zidentyfikuj odpowiednie rodzaje zagrożeń i określ zakres oceny.
2. **Ocena Potrzeb i Luk (OPL)**: Oceń możliwości w cyklu zarządzania katastrofami, zidentyfikuj luki i potrzeby doskonalenia.
3. **Ocena Rozwiązań (OR)**: Oceń potencjalne rozwiązania dla zidentyfikowanych luk w możliwościach, w tym zgodność, potrzeby użytkowników i ocenę wpływu.
4. **Plan Działania (PD)**: Zaplanuj harmonogramy wdrożenia i zaangażowanie dla wybranych rozwiązań.

##### Pierwsze Kroki

- Utwórz lub otwórz sesję oceny ze strony głównej
- Poruszaj się przez 4 kroki, używając ikon na pasku narzędzi
- Przełączaj się między rolami Użytkownika i Redaktora za pomocą selektora poniżej

##### Role

- **Zwykły Użytkownik**: Może wypełniać oceny i przeglądać wyniki
- **Moderator**: Może edytować konfigurację frameworka (rodzaje zagrożeń, możliwości, interesariusze)
- **Administrator**: Może modyfikować skale oceny i ustawienia

##### Kontekst

Projekt ten otrzymał finansowanie z programu badań i innowacji Horizon 2020 Unii Europejskiej. Opracowany przez TNO w ramach projektu [DIREKTION](https://www.direktion-network.org).`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Gotowe - Wyslij wyniki",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
